import { useEffect, useState } from "react"
import { defaultCardSelection, GroupHeader, groupSelector, mainHeader, selectHeader, singleAnswerForm } from "./functions"

const structureOpt = [
  "Concreto Armado in loco",
  "Fibra",
  "Concreto Pré-moldado",
  "Outro",
  "Definir Posteriormente"
];

const upperFinishOpt = [
  "Mesmo revestimento da piscina",
  "Pedra Natural",
  "Porcelanato",
  "Concreto",
  "PVC",
  "Peça Cerâmica",
  "Pastilha",
  "Outro",
  "Definir Posteriormente"
];

const externalFinishOpt = [
  "Mesmo revestimento da piscina",
  "Peça Cerâmica",
  "Pastilha",
  "Porcelanato",
  "Pedra Natural",
  "Vinílico",
  "Laminado de Madeira",
  "Ladrilhos Hidráulicos",
  "Pintura",
  "Textura Branca + Pintura",
  "Textura Pigmentada",
  "Nenhum",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];

const questions = [
  {
    label: "Qual estrutura da piscina?",
    options: structureOpt,
    name: "structure"
  },
  {
    label: "Qual acabamento superior da piscina?",
    options: upperFinishOpt,
    name: "upperFinish"
  },
  {
    label: "Qual acabamento externo da piscina?",
    options: externalFinishOpt,
    name: "externalFinish"
  },
  {
    label: "A escada da piscina possui corrimão?",
    options: ["Sim", "Não"],
    name: "poolHasHandrail"
  },
]


const PoolQuestions = ({ onGroupsChange, formData, preGroup, finished }) => {
  const [groups, setGroups] = useState([])
  const [currentGroup, setCurrentGroup] = useState([])
  const [formatPav, setFormatPav] = useState([])
  const [toggle, setToggle] = useState(true)
  const { pools } = formData.roomDefinitions
  const { pavements } = formData
  const [visibleGroups, setVisibleGroups] = useState([])

  const handleGroup = (e) => {
    if (finished) return;
    if (!currentGroup.includes(e)) {
      setCurrentGroup([...currentGroup, e])
    } else {
      setCurrentGroup(currentGroup.filter(i => i !== e))
    }
  }

  const finishGroup = () => {
    setGroups([...groups, { rooms: currentGroup.sort(), structure: "", upperFinish: "", externalFinish: "" }])
    setCurrentGroup([])
  }

  useEffect(() => {
    onGroupsChange(groups)
  }, [groups])

  useEffect(() => {
    if (groups.length > 0) {
      const elem = document.getElementById(`piscinas-${groups.length - 1}`);
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [groups.length])

  const checkRemaining = (arr) => {
    const remaining = arr?.filter(i => !groups.flatMap(group => group.rooms).includes(i));
    return remaining;
  }

  const selectAll = () => {
    if (currentGroup.join('') === checkRemaining(pools).join('')) {
      setCurrentGroup([])
    } else {
      setCurrentGroup(checkRemaining(pools))
    }
  }

  useEffect(() => {
    const pavs = pavements.map(i => {
      return {
        pavement: i.pavement,
        rooms: i.rooms.filter(j => pools.includes(j))
      }
    })
    setFormatPav(pavs.filter(i => i.rooms.length > 0));
    setGroups(preGroup || [])
  }, [])

  const selectBulk = (priv) => {
    const privAreas = formData.roomDefinitions.privAreas.filter(i => formData.roomDefinitions.pools.includes(i))
    if (priv) {
      setCurrentGroup(privAreas);
    } else {
      const common = formData.rooms.filter(i => !privAreas.includes(i)).filter(i => formData.roomDefinitions.pools.includes(i))
      setCurrentGroup(common)
    }
  }

  const handleChanges = (e, idx, field) => {
    if (finished) return;
    const newGroups = [...groups];
    newGroups[idx][field] = e;
    setGroups(newGroups);
  }

  const resetGroup = (idx) => {
    const newGroups = [...groups];
    newGroups.splice(idx, 1);
    setGroups(newGroups);
    setCurrentGroup([]);
  }

  const resetAll = () => {
    setGroups([])
  }

  const handleToggle = (idx) => {
    if (visibleGroups.includes(idx)) {
      setVisibleGroups(visibleGroups.filter(i => i !== idx))
    } else {
      setVisibleGroups([...visibleGroups, idx])
    }
  }

  return <div className="form-section">
    {mainHeader("Piscinas", groups, resetAll, toggle, setToggle)}

    {toggle && <>

      {groups.length > 0 && <>
        {groups.map((i, idx) => {
          return <div id={`piscinas-${idx}`} key={idx}>
            <GroupHeader idx={idx} rooms={i.rooms} handleToggle={handleToggle} active={visibleGroups.includes(idx)} groups={groups} setGroups={setGroups} setCurrentGroup={setCurrentGroup} />

            {visibleGroups.includes(idx) && <div className="group-questions-container">
              {questions.map(({ label, options, name }) => {
                return singleAnswerForm(label,
                  options,
                  idx,
                  name,
                  formData.projRoomFull,
                  "Piscina",
                  groups[idx],
                  handleChanges,
                  finished)
              })}
            </div>}


          </div>
        })}
      </>}

      {checkRemaining(pools).length > 0 && <>
        <label className="margin-tier-2 select-groups-header">Selecionar grupos</label>
        {selectHeader(selectAll, selectBulk)}
      </>}

      {groupSelector(formatPav, groups, currentGroup, handleGroup, finishGroup, pools)}
    </>}
  </div>
}

export default PoolQuestions;